const account_center = {
    not_enabled: 'Centro account non è abilitato.',
    filed_not_editable: 'Il campo non è modificabile.',
};
export default Object.freeze(account_center);
